import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { assignRoleApi, getRole, getRoles, getRoleUsers, putRole, removeRoleApi } from '../../services/api/roles.api';
import User from '../models/user.model';

export const fetchRoles = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'roles',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            const response = await getRoles(token, params);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching roles.");
            } else {
                return rejectWithValue('An error occurred while fetching roles.');
            }
        }
    }
);

export const fetchRole = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'role',
    async (id, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            const response = await getRole(token, id);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching role.");
            } else {
                return rejectWithValue('An error occurred while fetching role.');
            }
        }
    }
);

export const updateRole = createAsyncThunk<any, {id:string, name:string, description:string}, { rejectValue: string; state: RootState}>(
    'role/update',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await putRole(token, updateInfo);

            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while updating role.");
            } else {
                return rejectWithValue('An error occurred while updating role.');
            }
        }
    } 

);

export const fetchRoleUsers = createAsyncThunk<any, {id:string,page:string}, { rejectValue: string; state: RootState}>(
    'role/user',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            const response = await getRoleUsers(token, params);
            return response.data;
            
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching role users.");
            } else {
                return rejectWithValue('An error occurred while fetching role users.');
            }
        }
    }
);

export const assignRole = createAsyncThunk<any, {role_id:string, users:any[]}, { rejectValue: string; state: RootState}>(
    'role/assign',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await assignRoleApi(token, updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while assigning role.");
            } else {
                return rejectWithValue('An error occurred while assigning role.');
            }
        }
    } 
);

export const removeRole = createAsyncThunk<any, {role_id:string, users:User[]}, { rejectValue: string; state: RootState}>(
    'role/remove',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await removeRoleApi(token, updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while removing role.");
            } else {
                return rejectWithValue('An error occurred while removing role.');
            }
        }
    } 
);